// extracted by mini-css-extract-plugin
export default {"tableHeader":"TableHeader_tableHeader__8mgr4"};